/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DeviceUptimeResponse
 */
export interface DeviceUptimeResponse {
    /**
     * The uptime of the device. Offline periods are not considered in the availability calculation. i.e., device assumed to be continuously online.
     * @type {number}
     * @memberof DeviceUptimeResponse
     */
    uptimeOfflineIncluded?: number;
    /**
     * The uptime of the device. Offline periods are removed from the availability calculation.
     * @type {number}
     * @memberof DeviceUptimeResponse
     */
    uptimeOfflineExcluded?: number;
    /**
     * The preferred uptime value based on organisation preference. Defaults to UptimeOfflineIncluded if preference not set.
     * @type {number}
     * @memberof DeviceUptimeResponse
     */
    preferredUptime?: number;
    /**
     * Indicates which calculation method was used for PreferredUptime. true = offline included, false = offline excluded.
     * @type {boolean}
     * @memberof DeviceUptimeResponse
     */
    isOfflineIncluded?: boolean;
    /**
     * Calculation period start.
     * @type {Date}
     * @memberof DeviceUptimeResponse
     */
    periodStart?: Date;
    /**
     * Calculation period end.
     * @type {Date}
     * @memberof DeviceUptimeResponse
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the DeviceUptimeResponse interface.
 */
export function instanceOfDeviceUptimeResponse(
    value: object,
): value is DeviceUptimeResponse {
    return true;
}

export function DeviceUptimeResponseFromJSON(json: any): DeviceUptimeResponse {
    return DeviceUptimeResponseFromJSONTyped(json, false);
}

export function DeviceUptimeResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceUptimeResponse {
    if (json == null) {
        return json;
    }
    return {
        uptimeOfflineIncluded:
            json["uptimeOfflineIncluded"] == null
                ? undefined
                : json["uptimeOfflineIncluded"],
        uptimeOfflineExcluded:
            json["uptimeOfflineExcluded"] == null
                ? undefined
                : json["uptimeOfflineExcluded"],
        preferredUptime:
            json["preferredUptime"] == null
                ? undefined
                : json["preferredUptime"],
        isOfflineIncluded:
            json["isOfflineIncluded"] == null
                ? undefined
                : json["isOfflineIncluded"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function DeviceUptimeResponseToJSON(
    value?: DeviceUptimeResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        uptimeOfflineIncluded: value["uptimeOfflineIncluded"],
        uptimeOfflineExcluded: value["uptimeOfflineExcluded"],
        preferredUptime: value["preferredUptime"],
        isOfflineIncluded: value["isOfflineIncluded"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
